import * as React from "react"

export const Stat: React.FC = ({ children }) => {
  return (
    <div className="flex flex-col p-8 basis-0 grow justify-between">
      {children}
    </div>
  )
}
